module.exports = __webpack_public_path__ + "img/icon-new-yd.7443bd5.svg";